export default "images/剩余电量-中低电量.png";